<!-- Dados da IES Emissora -->
<ng-container *ngIf="tipo=='dados-ies'">
  <div class="body">
    <label>Nome</label>
    <p>{{dados.nome}}</p>
    <label>Código MEC</label>
    <p>{{dados.codigoMEC}}</p>
    <label>CNPJ</label>
    <p>{{dados.cnpj}}</p>

    <ng-container *ngIf="dados.endereco != undefined">
      <h5>Endereço</h5>
      <label>Logradouro</label>
      <p>{{dados.endereco.logradouro}}</p>
      <label>Bairro</label>
      <p>{{dados.endereco.bairro}}</p>
      <label>CEP</label>
      <p>{{dados.endereco.cep}}</p>
      <label>Município</label>
      <p>{{dados.endereco.municipio}}</p>
      <label>Código do Município</label>
      <p>{{dados.endereco.codigoMunicipio}}</p>
      <label>UF</label>
      <p>{{dados.endereco.uf}}</p>
      <label>Número</label>
      <p>{{dados.endereco.numero}}</p>
      <label>Complemennto</label>
      <p>{{dados.endereco.complemennto}}</p>
    </ng-container>

    <ng-container *ngIf="dados.credenciamento != undefined">
      <h5>Credenciamento</h5>
      <label>Tipo</label>
      <p>{{dados.credenciamento.tipo}}</p>
      <label>Número</label>
      <p>{{dados.credenciamento.numero}}</p>
      <label>Data</label>
      <p>{{dados.credenciamento.data | date: 'dd/MM/yyyy'}}</p>
      <label>Seção</label>
      <p>{{dados.credenciamento.secao}}</p>
      <label>Página</label>
      <p>{{dados.credenciamento.pagina}}</p>
      <label>Data de Publicação</label>
      <p>{{dados.credenciamento.dataPublicacao | date: 'dd/MM/yyyy'}}</p>
    </ng-container>

    <ng-container *ngIf="dados.recredenciamento != undefined">
      <h5>Recredenciamento</h5>
      <label>Recredenciado</label>
      <p>{{dados.recredenciamento.tipo}}</p>
      <label>Número</label>
      <p>{{dados.recredenciamento.numero}}</p>
      <label>Data</label>
      <p>{{dados.recredenciamento.dataPublicacao | date: 'dd/MM/yyyy'}}</p>
      <label>Seção</label>
      <p>{{dados.recredenciamento.secaoPublicacao}}</p>
      <label>Página</label>
      <p>{{dados.recredenciamento.paginaPublicacao}}</p>
      <label>Data de Publicação</label>
      <p>{{dados.recredenciamento.dataPublicacao | date: 'dd/MM/yyyy'}}</p>
    </ng-container>

    <ng-container *ngIf="dados.manetenedora != undefined">
      <h5>Dados da Mantenedora</h5>
      <label>Código EMEC</label>
      <p>{{dados.mantenedora.codigoEMEC}}</p>
      <label>Razão Social</label>
      <p>{{dados.mantenedora.razaoSocial}}</p>
      <label>CNPJ</label>
      <p>{{dados.mantenedora.cnpj}}</p>

      <label>Logradouro</label>
      <p>{{dados.mantenedora.endereco.logradouro}}</p>
      <label>Número</label>
      <p>{{dados.mantenedora.endereco.numero}}</p>
      <label>Bairro</label>
      <p>{{dados.mantenedora.endereco.bairro}}</p>
      <label>CEP</label>
      <p>{{dados.mantenedora.endereco.cep}}</p>
      <label>Município</label>
      <p>{{dados.mantenedora.endereco.municipio}}</p>
      <label>Código do Município</label>
      <p>{{dados.mantenedora.endereco.codigoMunicipio}}</p>
      <label>UF</label>
      <p>{{dados.mantenedora.endereco.uf}}</p>
      <label>Número</label>
      <p>{{dados.mantenedora.endereco.numero}}</p>
      <label>Complemento</label>
      <p>{{dados.mantenedora.endereco.complemento}}</p>
    </ng-container>
  </div>
</ng-container>

<!-- Dados do Curso -->
<ng-container *ngIf="tipo=='dados-curso'">
  <div class="body">
    <label>Nome do Curso</label>
    <p>{{dados.nome}}</p>
    <label>Código Curso EMEC</label>
    <p>{{dados.codigoCursoEMEC}}</p>
    <label>Titulo Conferido</label>
    <p>{{dados.nomeHabilitacaoTituloConferido}}</p>
    <label>Grau Conferido</label>
    <p>{{dados.grauConferido}}</p>

    <ng-container *ngIf="dados.endereco != undefined">
      <h5>Endereço</h5>
      <label>Logradouro</label>
      <p>{{dados.endereco.logradouro}}</p>
      <label>Número</label>
      <p>{{dados.endereco.numero}}</p>
      <label>Complemento</label>
      <p>{{dados.endereco.complemento}}</p>
      <label>Bairro</label>
      <p>{{dados.endereco.bairro}}</p>
      <label>CEP</label>
      <p>{{dados.endereco.cep}}</p>
      <label>Município</label>
      <p>{{dados.endereco.municipio}}</p>
      <label>Código do Município</label>
      <p>{{dados.endereco.codigoMunicipio}}</p>
      <label>UF</label>
      <p>{{dados.endereco.uf}}</p>
    </ng-container>

    <ng-container *ngIf="dados.autorizacao != undefined">
      <h5>Autorização</h5>
      <label>Tipo</label>
      <p>{{dados.autorizacao.tipo}}</p>
      <label>Número</label>
      <p>{{dados.autorizacao.numero}}</p>
      <label>Data</label>
      <p>{{dados.autorizacao.data | date: 'dd/MM/yyyy'}}</p>
      <label>Seção</label>
      <p>{{dados.autorizacao.secao}}</p>
      <label>Página</label>
      <p>{{dados.autorizacao.pagina}}</p>
      <label>Data de Publicação</label>
      <p>{{dados.autorizacao.dataPublicacao | date: 'dd/MM/yyyy'}}</p>
    </ng-container>

    <ng-container *ngIf="dados.reconhecimento != undefined">
      <h5>Reconhecimento</h5>
      <label>Tipo</label>
      <p>{{dados.reconhecimento.tipo}}</p>
      <label>Número</label>
      <p>{{dados.reconhecimento.numero}}</p>
      <label>Data</label>
      <p>{{dados.reconhecimento.data | date: 'dd/MM/yyyy'}}</p>
      <label>Seção</label>
      <p>{{dados.reconhecimento.secao}}</p>
      <label>Página</label>
      <p>{{dados.reconhecimento.pagina}}</p>
      <label>Data de Publicação</label>
      <p>{{dados.reconhecimento.dataPublicacao | date: 'dd/MM/yyyy'}}</p>
    </ng-container>

    <ng-container *ngIf="dados.renovacaoReconhecimento != undefined">
      <h5>Renovação Reconhecimento</h5>
      <label>Tipo</label>
      <p>{{dados.renovacaoReconhecimento.tipo}}</p>
      <label>Número</label>
      <p>{{dados.renovacaoReconhecimento.numero}}</p>
      <label>Data</label>
      <p>{{dados.renovacaoReconhecimento.data | date: 'dd/MM/yyyy'}}</p>
      <label>Seção</label>
      <p>{{dados.renovacaoReconhecimento.secao}}</p>
      <label>Página</label>
      <p>{{dados.renovacaoReconhecimento.pagina}}</p>
      <label>Data de Publicação</label>
      <p>{{dados.renovacaoReconhecimento.dataPublicacao | date: 'dd/MM/yyyy'}}</p>
    </ng-container>
  </div>
</ng-container>
